import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Constants from '../../Constants';
import LoginTextField from '../elements/editors/mui/LoginTextField';
import { isValidEmail } from '../../lib/ValidationUtils';
import { Button } from 'new/elements/Button';
import { GoogleRecaptcha } from 'new/elements/GoogleRecaptcha';
import { captchaSettings } from 'js/constants/config';

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isInputValid: this._getIsInputValid(props),
    };

    this._handleEmailChanged = this._handleEmailChanged.bind(this);
    this._handleRecaptchaChanged = this._handleRecaptchaChanged.bind(this);
  }

  render() {
    return (
      <div>
        <h2>Reset my password</h2>
        <p>Enter the email address associated with your account to receive a password reset.</p>
        <form>
          <div className="signup-form-item">
            <LoginTextField
              required
              autoFocus
              type="email"
              label="Email address"
              value={this.props.email ? this.props.email : ''}
              onChange={this._handleEmailChanged}
            />
          </div>
          <GoogleRecaptcha
            type={captchaSettings.reset_password?.type}
            className="signup-form-item"
            style={{ height: '78px' }}
            sitekey={captchaSettings.reset_password?.sitekey}
            onChange={this._handleRecaptchaChanged}
            onExpired={this._handleRecaptchaChanged}
          />
          <Button
            onClick={this.props.onSubmit}
            type="submit"
            variant="contained"
            color="primary"
            style={{ width: '100%' }}
            disabled={!this.state.isInputValid}
          >
            Reset password
          </Button>
        </form>
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.email !== prevProps.email ||
      this.props.gRecaptchaResponse !== prevProps.gRecaptchaResponse
    ) {
      this.setState({
        isInputValid: this._getIsInputValid(this.props),
      });
    }
  }

  _handleEmailChanged(event) {
    this.props.onInputChanged('email', event.target.value);
  }

  _handleRecaptchaChanged(response) {
    this.props.onInputChanged('gRecaptchaResponse', response);
  }

  _getIsInputValid(props) {
    const { email, gRecaptchaResponse } = props;
    return gRecaptchaResponse && isValidEmail(email);
  }
}

export default ResetPasswordForm;
